import {
  Box,
  useTheme,
  Container,
  Typography,
  useMediaQuery,
} from "@mui/material";
import useFaqs from "./useFaqs";
import { Fragment } from "react";
import CSkeleton from "./Skeleton";
import CTextField from "components/CTextField";
import { Section } from "typedef/ResponseGladly";
import color from "context/MaterialUITheme/color";
import CAccordion from "components/CAccordion/CAccordion";
import CAccordionItem from "components/CAccordion/CAccordionItem";

export default function Faqs() {
  const faq = useFaqs();
  const theme = useTheme();

  return (
    <Fragment>
      <Container
        maxWidth={false}
        sx={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: color.purple,
        }}
      >
        <Box
          maxWidth="lg"
          width={"100%"}
          display={"flex"}
          p={{ xs: 0, md: 6 }}
          mt={{ xs: 3, md: 0 }}
          mb={{ xs: 2, md: 0 }}
          alignItems={"center"}
          flexDirection={{ xs: "column", md: "row" }}
        >
          <Box pl={{ xs: 0, md: 3 }} width={{ xs: "100%", md: "50%" }}>
            <Typography
              variant="h2"
              color={color.white}
              mb={{ xs: 2, md: 0 }}
              fontSize={{ xs: "2.4rem", md: "4rem" }}
            >
              Frequently <br />
              Asked Questions
            </Typography>
          </Box>
          <Box
            pr={{ xs: 0, md: 3 }}
            pb={{ xs: 2, md: 0 }}
            width={{ xs: "100%", md: "50%" }}
          >
            <CTextField
              fullWidth
              type={"search"}
              value={faq.searchTerm}
              placeholder={"Enter Keyword"}
              onChange={faq.handleChangeSearch}
            />
          </Box>
        </Box>
      </Container>
      <Container
        maxWidth="lg"
        disableGutters={useMediaQuery(theme.breakpoints.only("xs"))}
      >
        <Box
          pt={1}
          pb={4}
          pl={{ md: 8, xs: 2 }}
          pr={{ md: 8, xs: 2 }}
          bgcolor={color.white}
          sx={{ borderBottomLeftRadius: 30, borderBottomRightRadius: 30 }}
        >
          {!faq.response?.sections && <CSkeleton />}
          {faq.searchTerm.length === 0 && (
            <Box>
              {faq.response?.sections?.map(
                (section: Section, i, { length }) => (
                  <CAccordion
                    key={section.id}
                    id={section.id}
                    header={section.header}
                    answerIds={section.answerIds}
                    last={i === length - 1}
                  />
                )
              )}
            </Box>
          )}
          {faq.searchTerm.length > 0 && (
            <Box>
              <Typography variant="h4" color={color.black} mt={2} mb={2}>
                More results:
              </Typography>
              {!faq.searchResult && <CSkeleton simple={true} />}
              {faq.searchResult?.map((id, i, { length }) => (
                <CAccordionItem
                  answerId={id?.id}
                  key={id?.id}
                  last={i === length - 1}
                />
              ))}
              {faq.searchResult?.length === 0 && (
                <Typography variant="h6">
                  No results were found for your search...
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Container>
    </Fragment>
  );
}
